export const expandLeftToolbar = payload => {
  return {
    type: 'LEFT_TOOLBAR_EXPAND',
    payload
  }
}

export const collapseLeftToolbar = () => {
  return {
    type: 'LEFT_TOOLBAR_COLLAPSE'
  }
}